
import React, { useState } from "react";
import { Accordion, AccordionSummary, Typography, Box, Card, Grid,Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import PersonalDetailsForm from "../Authentication/personalDetailsOldForm";

const profileDetails = [
    { label: "Company Name", value: "ABc Tech" },
    { label: "Location", value: "marthahalli" },
    { label: "Working Exp", value: "8 yrs" },
    { label: "Designation", value: "Software Engineer" },
    { label: "City", value: "Bengaluru" },
    { label: "Income", value: "12 lpa" },
];

const ProfileView = ({ professionalData,profileId }) => {
    let getMyProfileData = localStorage.getItem("profileData")
    let MyProfileData = JSON.parse(getMyProfileData)
    let userType = sessionStorage.getItem("userType")
    const [expanded, setExpanded] = useState(null);
    const navigate = useNavigate()
    const [open,setOpen] = useState(false)
    
    if (!professionalData) {
        return <p>No profile data available.</p>;
    }
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    return (
        <Box>
            {/* <Accordion
                expanded={expanded === "profile"}
                onChange={handleChange("profile")}
                sx={{ backgroundColor: "#C1721F", mb: 2, color: "white" }}
            > */}
            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // alignItems: 'center',
                                // padding: '10px',
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: '"Roboto Condensed", sans-serif',
                                  fontWeight: 600,
                                  fontSize: '24px',
                                  // lineHeight: '100%',
                                  letterSpacing: '0%',
                                }}
                              >
                                Professional Details
                              </Typography>
                            
                              {((MyProfileData && MyProfileData.id == profileId) || userType) && <Button
                                variant="contained"
                                // onClick={()=>navigate("/profile/education", { state: { type: "edit" } })}
                                onClick={() => setOpen(!open)}

                                sx={{
                                  backgroundColor: '#C1721F',
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'right',
                                  gap: '5px',
                                }}
                              >
                    {open ? "View" : "Edit"} 
                    </Button> }
                            </Box>
                {/* <AccordionSummary
                    expandIcon={expanded === "profile" ? <RemoveIcon sx={{ color: "white" }} /> : <AddIcon sx={{ color: "white" }} />}
                > */}
                    {/* <Typography
                        sx={{
                            fontFamily: '"Roboto Condensed", sans-serif',
                            fontWeight: 600,
                            fontSize: '24px',
                            lineHeight: '100%',
                            letterSpacing: '0%',
                            padding: "10px"
                        }}
                    >Professional Details</Typography>
                </AccordionSummary> */}
                {!open ? <Card
                    sx={{
                        ...styles.cardeducation,
                        height: { xs: "auto", sm: 'auto' },
                        padding: { xs: 2, sm: 4 },
                        borderRadius: "5px"
                    }}
                >
                    <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                    <Box sx={{
                        width: "100%",
                        margin: "auto",
                        backgroundColor: "white",
                        border: "2px solid #C1721F",
                        padding: { xs: "10px", sm: "20px 100px" },
                        borderRadius: "10px",
                        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                    }}>
                        <Grid container spacing={2}>
                            {professionalData && Object.entries(professionalData).map(([label, value], index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        px: 3,
                                        py: 1.5,
                                        // borderBottom: "1px solid #ddd", // optional separator
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        fontWeight="bold"
                                        sx={{ textAlign: "start", color: "#333",fontSize:"18px" }}
                                    >
                                        {label}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{ textAlign: "end", color: "#555", maxWidth: "60%" }}
                                    >
                                        {Array.isArray(value)
                                            ? value.length > 0
                                                ? value.join(", ")
                                                : "--"
                                            : value || "--"}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Card> : <PersonalDetailsForm type="edit"/>}

            {/* </Accordion> */}
        </Box>
    );
};

export default ProfileView;
